import React, { useState } from "react";
import classes from "./index.module.scss";
import classNames from "classnames";
import useQuery from "utils/useQuery";

export type StatusType = "all" | "sign" | "unSign";

interface StaticsProps {
    courseStuCount: number;
    signInStuCount: number;
    notSingInStuCount: number;
    onChange: (val: StatusType) => void;
}

export default function Statics({
    courseStuCount,
    notSingInStuCount,
    signInStuCount,
    onChange
}: StaticsProps) {
    const { status = "all" } = useQuery<{ status: StatusType }>();
    const [active, setActive] = useState<StatusType>(status);

    // 点击统计数字
    function onClickStatic(status: StatusType) {
        setActive(status);
        onChange(status);
    }

    return (
        <div className={classes.root}>
            <div
                className={classNames(classes.statics, {
                    [classes.active]: active === "all"
                })}
                onClick={() => onClickStatic("all")}>
                <em>{courseStuCount}</em>课程人数
            </div>
            <div
                className={classNames(classes.statics, {
                    [classes.active]: active === "sign"
                })}
                onClick={() => onClickStatic("sign")}>
                <em>{signInStuCount}</em>已签到
            </div>
            <div
                className={classNames(classes.statics, {
                    [classes.active]: active === "unSign"
                })}
                onClick={() => onClickStatic("unSign")}>
                <em>{notSingInStuCount}</em>未签到
            </div>
        </div>
    );
}
